// List setting collections with design page.
// They must be handle to distinguish them from regular collections. (Ex: select-a...)
function getDyoLocaleRootPath() {
  const root = window.Shopify?.routes?.root || '/';
  const rootPath = root.replace(window.location.origin, '').split('?')[0].replace(/\/$/, '');
  return rootPath === '/' ? '' : rootPath;
}

function buildDyoStorefrontPath(path) {
  const localeRootPath = getDyoLocaleRootPath();
  const parsedUrl = new URL(path || '/', window.location.origin);

  if (parsedUrl.origin !== window.location.origin) {
    return parsedUrl.toString();
  }

  let storefrontPath = parsedUrl.pathname || '/';
  if (localeRootPath && storefrontPath !== localeRootPath && storefrontPath.indexOf(`${localeRootPath}/`) !== 0) {
    storefrontPath = `${localeRootPath}${storefrontPath}`;
  }

  return `${storefrontPath.replace(/\/{2,}/g, '/')}${parsedUrl.search}${parsedUrl.hash}`;
}

window.DYObuildStorefrontPath = buildDyoStorefrontPath;

function stripDyoLocaleRootPath(path) {
  const localeRootPath = getDyoLocaleRootPath();
  let storefrontPath = (path || '/').split('?')[0].split('#')[0];

  if (localeRootPath && storefrontPath.indexOf(`${localeRootPath}/`) === 0) {
    storefrontPath = storefrontPath.slice(localeRootPath.length);
  }

  return storefrontPath || '/';
}

window.DYOcollections = {
  "select-a-ring": buildDyoStorefrontPath("/pages/design-your-own-ring"),
  "select-an-earrings": buildDyoStorefrontPath("/pages/design-your-own-earrings"),
  "select-a-necklace": buildDyoStorefrontPath("/pages/design-your-own-necklace")
}

// Func analysis option 'Center Stone Size'
function analysisOptions(options) {
  let otherOptions = [], from = 0, to = 0;

  options.forEach(option => { // ["0.15 - 0.49Ct", "Metal", "18k Gold", ...];
    // Locale-tolerant by design: the values reach us as rendered, so a Translate &
    // Adapt translation (the 2026-10-11 auto-translate re-added them) sends
    // "5,00 – 6,99 Karat", "0,10 – 0,50 Kt." or even "9:00 - 10:00 CET", and a
    // miss silently drops the weight into otherOptions. Accept comma/colon decimals,
    // any hyphen or dash (U+2010-U+2015, U+2212) and the carat suffixes seen in the
    // data, then normalise back to a dot: everything downstream parseFloat()s these.
    const match = option.match(/(\d+(?:[.,:]\d+)?)\s*[-‐-―−]\s*(\d+(?:[.,:]\d+)?)\s*(?:ctw|cts?|cet|carati|carats?|karats?|kts?)\b/i);
    if (match) {
      from = match[1].replace(/[,:]/, '.');
      to = match[2].replace(/[,:]/, '.');
      return;
    }

    const singleCaratMatch = option.match(/(\d+(?:[.,:]\d+)?)\s*(?:ctw|cts?|cet|carati|carats?|karats?|kts?)\b/i);
    if (singleCaratMatch) {
      from = singleCaratMatch[1].replace(/[,:]/, '.');
      to = from;
    } else {
      otherOptions.push(option);
    }
  });

  return {
    from: from,                 // 0.15
    to: to,                     // 0.49
    otherOptions: otherOptions  // ["Metal", "18k Gold", ...]
  };
}
window.DYOanalysisOptions = analysisOptions;



function initializeDyoData(settingHandle, stoneHandle = '', start = 'setting') {
  const dyoData = JSON.parse(localStorage.getItem('dyo_data'));
  if (
    start !== 'stone'
    && dyoData?.process?.setting?.urlCollection?.includes(settingHandle)
  ) {
    return;
  }

  let settingType = settingHandle.split('-').pop() || 'ring';
  let iconStone = 'https://cdn.shopify.com/s/files/1/0799/4251/7035/files/icon-stone_53a07922-da1b-42f1-a963-5896711e57e1.png?width=100';
  let iconSetting;
  switch (settingType) {
    case 'earrings':
      iconSetting = 'https://cdn.shopify.com/s/files/1/0799/4251/7035/files/earring-active.png?width=100'
      break;
    case 'necklace':
      iconSetting = 'https://cdn.shopify.com/s/files/1/0799/4251/7035/files/icon-necklaces-active.png?width=100'
      break;
    default:
      iconSetting = 'https://cdn.shopify.com/s/files/1/0799/4251/7035/files/icon-ring-active.png?width=100';
      break;
  }

  const data = {
    general: {
      designUrl: buildDyoStorefrontPath(`/pages/design-your-own-${settingType}`),
      collections: {
        setting: settingHandle,
        diamond: `select-a-diamond${settingType == 'earrings' ? '-pair' : ''}`,
        stone: `select-a-gemstone${settingType == 'earrings' ? '-pair' : ''}`
      },
      heading: `Design Your Own ${settingType}`
    },
    process: {
      setting: {
        position: start === 'setting' ? 1 : 2,
        img: iconSetting,
        urlCollection: start === 'setting' ? buildDyoStorefrontPath(`/collections/${settingHandle}`) : '',
      },
      stone: {
        position: start === 'stone' ? 1 : 2,
        img: iconStone,
        urlCollection: start === 'stone' ? buildDyoStorefrontPath(`/collections/${stoneHandle}`) : ''
      }
    }
  }

  // Set data into Localstorage
  localStorage.setItem('dyo_data', JSON.stringify(data));
}
window.DYOinitializeDyoData = initializeDyoData;



function checkProcess() {
  var currentUrl = window.location.href;
  const dyoData = JSON.parse(localStorage.getItem('dyo_data'));
  
  if ( /* If in DYO process  */
    currentUrl.includes("/collections/select-a")
    || window.location.hash === "#dyo"
    || currentUrl.includes("/pages/confirmation-dyo") && !currentUrl.split('?')[1]
  ) {
    window.DYO_in_process = '#dyo'; // In process DYO

    /* View DYO collection page if dyo_data is empty then redirect to design page */
    const collectionSetting = Object.keys(window.DYOcollections).find(key => currentUrl.includes(key));
    if (collectionSetting) {
      if (!Object.values(dyoData?.general?.collections ?? {}).includes(collectionSetting)) {
        // window.location.replace(window.DYOcollections[collectionSetting]);
        window.DYOinitializeDyoData(collectionSetting);
        return;
      }
    }

    /* Redirect to design page if dyo_data has not been initialized and see stone/diamond collection  */
    if (
      currentUrl.includes("/collections/select-a-gemstone") || currentUrl.includes("/collections/select-a-diamond")
    ) {
      const pathWithoutLocale = stripDyoLocaleRootPath(window.location.pathname);
      const stoneCollectionPath = stripDyoLocaleRootPath(dyoData?.process?.stone?.urlCollection);
      if (
        !Object.values(dyoData?.general?.collections ?? {}).find(key => pathWithoutLocale === `/collections/${key}`)
        || dyoData?.process?.stone?.position == 1 && pathWithoutLocale != stoneCollectionPath
        || dyoData?.process?.stone?.position == 2 && !dyoData?.process?.setting?.productHandle
      ) {
        if (currentUrl.includes("-pair")) {
          window.location.replace(window.DYOcollections['select-an-earrings']);
          return;
        }
        window.location.replace(window.DYOcollections['select-a-ring']);
        return;
      }
      
    }

    /* Redirect to homepage if dyo_data has not been initialized  */
    if (
      !dyoData?.general?.collections
      || !dyoData?.process?.setting?.position
      || !dyoData?.process?.stone?.position
    ) {
      window.location.replace(buildDyoStorefrontPath("/"));
      return;
    }

    /* View DYO collection page (stone) if handle not valid with dyoData.general.collections then redirect to homepage  */
    if (
      currentUrl.includes("/collections/select-a")
      && !Object.values(dyoData.general.collections).some(handleValid => currentUrl.includes(handleValid))
    ) {
      window.location.replace(buildDyoStorefrontPath("/"));
      return;
    }
  }
}
window.DYOcheckProcess = checkProcess;
